import './../../Player.css';
import React, {useContext, useState} from 'react';
import { useTranslation } from 'react-i18next';
import { PlayerContext } from '../../PlayerContext';
import { openFullscreen, isFirefox, checkMobile } from '../../Utils';
import { analyticsManager } from '../../../index';
import SecondaryButton, {reviewsType} from '../components/SecondaryButton';
import FadeInPanel from '../components/FadeInPanel';
import { Alert, IconButton, Snackbar } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useMediaQuery } from 'react-responsive';
import { hasChainRestaurants } from '../../chainRestaurantUtils';
import { getStoredPixelConsent } from '../../PixelConsentOverlay';

function ReviewsButton(props){    
    const [isOpened, setIsOpened] = useState(false);

    const storyDimensions = useContext(PlayerContext).get("storyDimensions");
    const propagateFocusChange = useContext(PlayerContext).get("propagateFocusChange");
    const pauseVideo = useContext(PlayerContext).get("pauseVideo");
    const setActiveFeature = useContext(PlayerContext).get("setActiveFeature");
    const activeFeature = useContext(PlayerContext).get("activeFeature");
    const appAnalyticsManager = useContext(PlayerContext).get("appAnalyticsManager");
    const playMode = useContext(PlayerContext).get("playMode");
    const sizeMultiplier = useContext(PlayerContext).get("sizeMultiplier");
    const setPlayAudio = useContext(PlayerContext).get("setPlayAudio");
    const audioAlreadyDisabled = useContext(PlayerContext).get("audioAlreadyDisabled");
    const playerOnDesktop = useContext(PlayerContext).get("playerOnDesktop");
    const fromMaker = useContext(PlayerContext).get("fromMaker");
    const fromDemo = useContext(PlayerContext).get("fromDemo");
    const [showInfoRatingThreshold, setShowInfoRatingThreshold] = useState(false);
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
    const idPrefix = fromDemo ? (fromDemo +"-") : "";

    const { t } = useTranslation();

    if (props.story.posId == null && !hasChainRestaurants(props.story)) return (null);

    const reviewNbToShow = 3;
    const reviewsOuterMargin = 16 * sizeMultiplier;
    const reviewsCardRadius = 8 * sizeMultiplier;
    
    const open = () => {                       
        if (!fromMaker /*&& !fromDemo*/ && !playerOnDesktop && !audioAlreadyDisabled){            
            const ambiantPlayer = document.getElementById(idPrefix + "audio-player");
            if (ambiantPlayer && ambiantPlayer.paused){
                ambiantPlayer.play();
            }
            setPlayAudio(true);
        }
        pauseVideo();
        openFullscreen();
        setActiveFeature("reviews");
        setIsOpened(true);
        if (playMode === "preview"){
            setShowInfoRatingThreshold(true);
        }

        analyticsManager.logCheckReviewsTag(props.storyId, playMode, true);
        
        if (appAnalyticsManager)
            appAnalyticsManager.clickedReviews();

        if (getStoredPixelConsent() === 'accepted') {
            if (window.ttq){
                window.ttq.track('ViewContent', {                
                    "contents": [
                        {              
                            "content_id": "0",           
                            "content_name": "reviews",
                        }
                    ],
                });
            }
            if (window.fbq){                    
                window.fbq('track', 'ViewContent', {"content_name": "reviews"});
            }
        }
    };

    const close = () => {
        propagateFocusChange(true);
        setIsOpened(false);
        setActiveFeature(null);
        analyticsManager.logCheckReviewsTag(props.storyId, playMode, false);
    };

    function showInfoRatingThresholdSnack(){
    if (showInfoRatingThreshold){
        return (
            <Snackbar open={showInfoRatingThreshold} autoHideDuration={4000} onClose={()=>setShowInfoRatingThreshold(false)} anchorOrigin={{vertical: 'top', horizontal: isTabletOrMobile ? 'center' : 'right'}}>
                <Alert severity="info">     
                {t('AckHoursThreshold')}
                </Alert>
            </Snackbar>
        );
    }
        else return null;
    } 

    function showCloseButton(){
        return (
            <div style={{
                position: 'absolute',
                bottom: 16 * sizeMultiplier,
                left: 0,
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 40
            }}>
                
                <IconButton
                    onClick={close}
                    style={{
                        background: "#fff",
                        borderRadius: "50%",                                
                        padding: 4 * sizeMultiplier,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}                        
                >                                     
                    <CloseIcon style={{ color: "#808080", fontSize: 24 * sizeMultiplier, width: 28 * sizeMultiplier, height: 28 * sizeMultiplier,}} />                        
                </IconButton>
            </div>
        );                    
    }

    const reviewsCloseReserve = 56 * sizeMultiplier;
    const reviewsAvailableHeight = storyDimensions.containerHeight - reviewsCloseReserve;

    const reviewsRootStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        width: storyDimensions.containerWidth,
        height: storyDimensions.containerHeight,
        pointerEvents: 'auto',
        zIndex: 20,
    };

    const reviewsCardStyle = {
        zIndex: 10,
        position: 'absolute',
        top: reviewsAvailableHeight / 2,
        left: reviewsOuterMargin,
        right: reviewsOuterMargin,
        transform: 'translateY(-50%)',
        backgroundColor: '#FFFFFF',
        borderRadius: reviewsCardRadius,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
        maxHeight: reviewsAvailableHeight - 2 * reviewsOuterMargin,
    };

    const reviewsCardScrollStyle = {
        overflowX: 'hidden',
        overflowY: 'auto',
        flex: 1,
        minHeight: 0,
        WebkitOverflowScrolling: 'touch',
        touchAction: 'pan-y',
    };

    const reviewsScrollContentStyle = {
        // Les blocs texte interceptent le scroll tactile ; laisser le conteneur parent gérer le défilement.
        pointerEvents: 'none',
    };

    function renderCardBand(){
        return (
            <div style={{
                width: '100%',
                height: 30 * sizeMultiplier,
                backgroundColor: props.story.primaryColor,
                borderTopLeftRadius: reviewsCardRadius,
                borderTopRightRadius: reviewsCardRadius,
                flexShrink: 0,
            }} />
        );
    }

    function formatReviewCountLabel(userRatingCount){
        const count = Number(userRatingCount) || 0;
        if (count === 0 || count === 1) {
            return t('GoogleReviewCountSingular', { count });
        }
        return t('GoogleReviewCountPlural', { count });
    }

    function renderStarRow(rating, starSize, keyPrefix = 'global'){
        const numericRating = Number(rating) || 0;
        const stars = [];
        const starPad = Math.max(1, Math.round(sizeMultiplier));

        for (let index = 1; index <= 5; index++) {
            const fillRatio = Math.min(1, Math.max(0, numericRating - (index - 1)));
            stars.push(
                <span
                    key={`${keyPrefix}-star-${index}`}
                    style={{
                        position: 'relative',
                        width: starSize,
                        height: starSize + starPad,
                        display: 'inline-block',
                        flexShrink: 0,
                        lineHeight: 0,
                        overflow: 'visible',
                    }}
                >
                    <img
                        alt=""
                        aria-hidden="true"
                        src="/images/star.png"
                        style={{
                            display: 'block',
                            width: starSize,
                            height: starSize,
                            objectFit: 'contain',
                            opacity: 0.28,
                            filter: 'grayscale(1)',
                            pointerEvents: 'none',
                        }}
                    />
                    <span style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: `${fillRatio * 100}%`,
                        height: starSize + starPad,
                        overflow: 'hidden',
                        lineHeight: 0,
                    }}>
                        <img
                            alt=""
                            aria-hidden="true"
                            src="/images/star.png"
                            style={{
                                display: 'block',
                                width: starSize,
                                height: starSize,
                                objectFit: 'contain',
                                pointerEvents: 'none',
                            }}
                        />
                    </span>
                </span>
            );
        }

        return stars;
    }

    function renderGlobalRating(rating, userRatingCount){
        const starSize = 14 * sizeMultiplier;
        const starPad = Math.max(1, Math.round(sizeMultiplier));
        const starRowHeight = starSize + starPad;
        const reviewCountFontSize = 12 * sizeMultiplier;
        const metaColumnGap = 4 * sizeMultiplier;
        const metaBlockHeight = starRowHeight + metaColumnGap + reviewCountFontSize * 1.2;
        // Les chiffres Roboto n'occupent pas toute la em-box : léger surplus pour aligner visuellement.
        const ratingFontSize = metaBlockHeight * 1.2;

        return (
            <div style={{
                padding: `${16 * sizeMultiplier}px`,
                borderBottom: `1px solid #E8E8E8`,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: 12 * sizeMultiplier,
                flexShrink: 0,
            }}>
                <div style={{
                    fontSize: ratingFontSize,
                    fontWeight: 400,
                    color: '#202124',
                    lineHeight: 1,
                    height: metaBlockHeight,
                    display: 'flex',
                    alignItems: 'center',
                    fontFamily: 'Roboto, sans-serif',
                    letterSpacing: '-0.5px',
                }}>
                    {Number(rating).toFixed(1)}
                </div>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    gap: 4 * sizeMultiplier,
                    minWidth: 0,
                }}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'flex-start',
                        gap: 1 * sizeMultiplier,
                        lineHeight: 0,
                        overflow: 'visible',
                    }}>
                        {renderStarRow(rating, starSize)}
                    </div>
                    <div style={{
                        fontSize: 12 * sizeMultiplier,
                        color: '#70757a',
                        fontFamily: 'Roboto, sans-serif',
                        lineHeight: 1.2,
                    }}>
                        {formatReviewCountLabel(userRatingCount)}
                    </div>
                </div>
            </div>
        );
    }

    function renderGoogleMapsAttribution(){
        const logoHeight = 16 * sizeMultiplier;

        return (
            <div
                translate="no"
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    paddingTop: 16 * sizeMultiplier,
                    paddingBottom: 20 * sizeMultiplier,
                }}
            >
                <img
                    alt="Google Maps"
                    src="/images/GoogleMaps_Logo_Gray_2x.png"
                    draggable={false}
                    style={{
                        height: logoHeight,
                        width: 'auto',
                        pointerEvents: 'none',
                        userSelect: 'none',
                        WebkitUserSelect: 'none',
                    }}
                />
            </div>
        );
    }

    function renderReviewItem(review, index, isLast){
        const reviewText = review.text?.text ?? "";

        return (
            <div
                key={`${review.authorAttribution?.displayName ?? "review"}-${index}`}
                style={{
                    padding: `${16 * sizeMultiplier}px ${16 * sizeMultiplier}px`,
                    borderBottom: isLast ? 'none' : `1px solid #E8E8E8`,
                }}
            >
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    <img
                        onLoad={(e) => e.target.style.color = 'white'}
                        onError={(e) => { e.target.style.display = "none"; }}
                        style={{
                            width: 42 * sizeMultiplier,
                            height: 42 * sizeMultiplier,
                            borderRadius: '50%',
                            objectFit: 'cover',
                            flexShrink: 0,
                            pointerEvents: 'none',
                        }}
                        alt={isFirefox() ? "" : "reviewer avatar"}
                        src={review.authorAttribution?.photoUri}
                    />
                    <div style={{marginLeft: 12 * sizeMultiplier, minWidth: 0, flex: 1}}>
                        <div style={{
                            fontSize: 16 * sizeMultiplier,
                            fontWeight: 'bold',
                            color: '#404040',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }}>
                            {review.authorAttribution?.displayName}
                        </div>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            gap: 8 * sizeMultiplier,
                            marginTop: 4 * sizeMultiplier,
                        }}>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'flex-start',
                                gap: 1 * sizeMultiplier,
                                lineHeight: 0,
                                overflow: 'visible',
                            }}>
                                {renderStarRow(review.rating, 12 * sizeMultiplier, `review-${index}`)}
                            </div>
                            <span style={{
                                fontSize: 12 * sizeMultiplier,
                                color: '#70757a',
                                fontFamily: 'Roboto, sans-serif',
                            }}>
                                {review.relativePublishTimeDescription}
                            </span>
                        </div>
                    </div>
                </div>
                <div style={{
                    marginTop: 12 * sizeMultiplier,
                    fontSize: 14 * sizeMultiplier,
                    color: '#404040',
                    lineHeight: 1.45,
                    whiteSpace: 'pre-line',
                }}>
                    {reviewText}
                </div>
            </div>
        );
    }

    function renderReviewsPanel(reviewItems, rating, userRatingCount){
        return (
            <FadeInPanel
                className="reviews-container"
                animationKey="reviews"
                style={reviewsRootStyle}
                onClick={(e) => e.stopPropagation()}
            >
                <div
                    id={idPrefix + "gallery-overlay"}
                    className="BlockingOverlay"
                    style={{
                        width: storyDimensions.containerWidth,
                        height: storyDimensions.containerHeight,
                        background: "#FFFFFFD0",
                        pointerEvents: 'auto',
                    }}
                />
                <div style={reviewsCardStyle} onClick={(e) => e.stopPropagation()}>
                    {renderCardBand()}
                    <div
                        className={(checkMobile() || fromDemo || playMode === "demo") ? "reviews-card-scroll-mobile" : "reviews-card-scroll-desktop"}
                        style={reviewsCardScrollStyle}
                    >
                        <div style={reviewsScrollContentStyle}>
                            {rating != null && userRatingCount != null && renderGlobalRating(rating, userRatingCount)}
                            {reviewItems}
                            {renderGoogleMapsAttribution()}
                        </div>
                    </div>
                </div>
                {showCloseButton()}
                {showInfoRatingThresholdSnack()}
            </FadeInPanel>
        );
    }
    
    if (props.show && props.story.premium){        
        if (isOpened && activeFeature === "reviews" && props.placeDetails && props.placeDetails.reviews && props.placeDetails.reviews.length > 0){
            const qualifyingReviews = props.placeDetails.reviews
                .filter((review) => review && review.rating >= 4)
                .slice(0, reviewNbToShow);

            const displayedReviews = qualifyingReviews.map((review, index) =>
                renderReviewItem(review, index + 1, index === qualifyingReviews.length - 1),
            );

            return renderReviewsPanel(
                displayedReviews,
                props.placeDetails.rating ?? 0,
                props.placeDetails.userRatingCount ?? 0,
            );
        }
        else if (isOpened && activeFeature === "reviews" && props.placeDetails){
            return renderReviewsPanel(
                null,
                props.placeDetails.rating ?? 0,
                props.placeDetails.userRatingCount ?? 0,
            );
        }
        else {                  
            return <SecondaryButton buttonType={reviewsType} open={open} story={props.story}/>;                               
        }
    }
    else return null;
}

export default ReviewsButton;